import { TimeMaker } from "@/plugins";
import { mapGetters } from "vuex";

export default (propName = "item", importLanguage = false) => {
  let computed = {
    isPublishScheduled() {
      const item = this[propName];
      if (item && item.events && item.events.length) {
        const found = item.events.find(x => x.event == "schedule_publish");
        if (found) {
          return true;
        }
      }
      return false;
    },
    publishScheduleAt() {
      const item = this[propName];
      if (item && item.events && item.events.length) {
        const found = item.events.find(x => x.event == "schedule_publish");
        if (found) {
          return new TimeMaker(found.event_at).ago(this.language);
        }
      }
      return "";
    },
  }
  if (importLanguage) {
    computed = {
      ...mapGetters("account", {
        language: "displayLanguage"
      }),
      ...computed
    }
  }
  return {
    computed: computed,
  }
};
